import * as React from 'react';
import { T } from '../../Translations';

interface Props {
  onRefresh?: () => void;
}

const IdleState: React.FC<Props> = ({ onRefresh }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-6 mb-4">
      {onRefresh && (
        <button
          onClick={onRefresh}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
        >
          <T kind="Generate AI Summary" />
        </button>
      )}
    </div>
  );
};

export default IdleState;
